import $ from "jquery";
import "../components/contact-component";
